import React, { Component } from "react";
import $ from "jquery";
import Delneshin from "../../MyFiles/Course.jpg";

class Cermony extends Component {
  constructor(props) {
    super(props);
    console.log("Cermony Constructor");
  }
  state = {
    errorMessage: "",
    stepNo: 1,
    isRegister: true,
  };
  componentDidMount() {
    this.props.getUserCermonyRequest();
    //console.log(this.props.userJson);
  }
  toggleRegister = () => {
    this.setState({ isRegister: !this.state.isRegister });
    //this.props.getAllUserRelation();
    // this.setState({stepNo: 2});
    // this.setState({isRegister: !this.state.isRegister});
  };
  toggleEdit = () => {
    this.props.getAllUserRelation();
    this.setState({ stepNo: 3 });
    this.setState({ isRegister: !this.state.isRegister });
  };
  toggleSubmit = () => {
    if (this.state.stepNo === 1) {
      this.props.getAllUserRelation();
      this.setState({ stepNo: 3 });
    }
    if (this.state.stepNo === 2) {
      this.props.getAllUserRelation();
      this.setState({ stepNo: 3 });
    }
    if (this.state.stepNo === 3) {
      this.submitCermonyForm();
    }
  };
  toggledecline = () => {
    if (this.state.stepNo === 1) {
      this.setState({ isRegister: !this.state.isRegister });
    }
    if (this.state.stepNo === 2) {
      this.setState({ stepNo: 1 });
    }
    if (this.state.stepNo === 3) {
      this.setState({ stepNo: 2 });
    }
  };
  selectRelation = (id, e) => {
    if (id !== null) {
      var cusid_ele = document.getElementsByClassName("dvRelation");
      for (var i = 0; i < cusid_ele.length; ++i) {
        var item = cusid_ele[i];
        var getValue = $(item).attr("data-target");
        if (getValue !== null && getValue.includes(id)) {
          item.classList.toggle("active");
        }
      }
    }
  };
  submitCermonyForm = () => {
    const token = localStorage.getItem("token");
    if (token !== null) {
      var selectRelationID = 0;
      var cusid_ele = document.getElementsByClassName("dvRelation");
      var TypeSelect = document.getElementById("ID_Type").value;
      console.log(TypeSelect);
      if (TypeSelect !== "1" && TypeSelect !== "2") {
        this.props.toggleErrorMessage("روز حضور در کارگاه را مشخص نمایید.");
        this.props.toggleError();
      } else {
        for (var i = 0; i < cusid_ele.length; ++i) {
          var item = cusid_ele[i];
          if (item.classList.contains("active") === true) {
            if (selectRelationID === 0) {
              selectRelationID = $(item).attr("data-target");
            } else {
              selectRelationID =
                selectRelationID + "," + $(item).attr("data-target");
            }
          }
        }
        var formdata = new FormData();
        formdata.append("token", token);
        formdata.append("ID_Relation", selectRelationID);
        formdata.append("ID_Type", TypeSelect);

        var requestOptions = {
          method: "POST",
          body: formdata,
          redirect: "follow",
        };

        fetch(
          `${process.env.REACT_APP_BASE_API_URL}/api/user/submit-cermony`,
          requestOptions
        )
          .then((response) => response.text())
          .then((result) => {
            if (result !== null) {
              // this.toggleBlocking();
              var myObject = JSON.parse(result);
              if (myObject.status === 0) {
                const errorMessage = "درخواست شما با موفقیت در سامانه ثبت شد.";
                this.props.toggleErrorMessage(errorMessage);
                this.props.toggleError();
                this.toggleRegister();
                this.props.getUserCermonyRequest();
              } else {
                const errorMessage = myObject.message;
                this.props.toggleErrorMessage(errorMessage);
                this.props.toggleError();
              }
            }
          })
          .catch((error) => console.log("error", error));
      }
    } else {
      const errorMessage =
        "مجدد وارد سامانه شوید، نشست شما به پایان رسیده است.";
      this.props.toggleErrorMessage(errorMessage);
      this.props.toggleError();
    }
  };
  handleRequest = (e) => {
    this.declineCermonyRequest(e);
  };
  declineCermonyRequest = (e) => {
    //console.log("APP-Get User Request");
    const token = localStorage.getItem("token");
    if (token !== null) {
      var formdata = new FormData();
      formdata.append("token", token);
      formdata.append("ID_Request", e);
      var requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
      };

      fetch(
        `${process.env.REACT_APP_BASE_API_URL}/api/refahi/del-user-cermony-request`,
        requestOptions
      )
        .then((response) => response.text())
        .then((result) => {
          if (result !== null) {
            // console.log(result);
            var myObject = JSON.parse(result);
            if (myObject.status === 0) {
              this.props.getUserCermonyRequest();
            } else {
              const errorMessage = myObject.message;
              this.props.toggleErrorMessage(errorMessage);
              this.props.toggleError();
            }
          }
        })
        .catch((error) => console.log("error", error));
    }
  };
  render() {
    const Relation_Active = this.props.userRelationsJson.map((e) =>
      e.NeedEdit !== true && e.Relation_ID === 10 ? (
        this.props.userCermonyRequestJson.filter(
          (ee) => ee.data_addition.National_Code === e.National_Code
        ) !== null ? (
          <div
            key={e.ID}
            className="col-12 mb-2 bg-light dvRelation"
            data-target={e.ID}
          >
            <div className="w-100 rounded p-1">
              <div className="row">
                <div className="col-2 m-auto checkbox">
                  {/* <input type="checkbox" /> */}
                  <label className="containerCustom">
                    <input
                      type="checkbox"
                      value={e.ID}
                      onClick={() => this.selectRelation(e.ID, this)}
                      name="User Relation Info"
                    ></input>
                    <span className="checkmark"></span>
                  </label>
                </div>
                <div className="col-10">
                  <span className="bg-dark text-white wp-text-small rounded p-1">
                    جنسیت: {e.Sex}
                  </span>{" "}
                  <span className="bg-dark text-white wp-text-small rounded p-1 mr-2">
                    نسبت: {e.Relation_Title}
                  </span>
                  <div className="title mt-1">
                    <strong>
                      {e.F_Name} {e.L_Name}
                    </strong>
                  </div>
                  <div className="describe">
                    کدملی: <b>{e.National_Code}</b>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div
            key={e.ID}
            className="col-12 mb-2 bg-light dvRelation"
            onClick={() => this.selectRelation(e.ID, this)}
            data-target={e.ID}
          >
            <div className="w-100 rounded p-1">
              <div className="row">
                <div className="col-2 m-auto checkbox">
                  <input type="checkbox" />
                </div>
                <div className="col-10">
                  <span className="bg-dark text-white wp-text-small rounded p-1">
                    جنسیت: {e.Sex}
                  </span>{" "}
                  <span className="bg-dark text-white wp-text-small rounded p-1 mr-2">
                    نسبت: {e.Relation_Title}
                  </span>
                  <div className="title mt-1">
                    <strong>
                      {e.F_Name} {e.L_Name}
                    </strong>
                  </div>
                  <div className="describe">
                    کدملی: <b>{e.National_Code}</b>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )
      ) : null
    );
    const myRelation = this.props.userRelationsJson.map((e) => (
      <li key={e.ID} className={"Array-item readClass"}>
        <span className="bg-dark text-white wp-text-small rounded p-1">
          جنسیت: {e.Sex}
        </span>{" "}
        <span className="bg-dark text-white wp-text-small rounded p-1 mr-2">
          نسبت: {e.Relation_Title}
        </span>
        <div className="title mt-1">
          <strong>
            {e.F_Name} {e.L_Name}
          </strong>
        </div>
        <div className="describe">
          کدملی: <b>{e.National_Code}</b>
        </div>
        <div className="describe">
          ش.شناسنامه: <b>{e.Identity_Code}</b>
        </div>
        <div className="describe">
          تاریخ تولد: <b>{e.DateOfBirthday}</b>
        </div>
        <div className="describe">
          محل صدور: <b>{e.Sodor_City}</b>
        </div>
        <div className="text-left">
          <span className={e.State_CSS}>{e.State_Title}</span>
        </div>
        {e.NeedEdit === true ? (
          <span className="bg-danger text-white wp-text-small">
            اطلاعات این فرد ناقص است، لطفاً نسبت به تکمیل اطلاعات فرد اقدام
            نمایید.
          </span>
        ) : null}
        <div className="text-left">
          <button
            type="button"
            onClick={() => this.props.getUserRelation(e.ID)}
            className="btn btn-warning btn-sm rounded-0 py-0 px-1 small-font"
          >
            ویرایش
          </button>
        </div>
      </li>
    ));
    const myRequest = this.props.userCermonyRequestJson.map((e) => (
      <li key={e.ID} className={"Array-item readClass"}>
        <span className="bg-dark text-white wp-text-small rounded p-1">
          تاریخ درخواست {e.RequestTime}
        </span>
        <div className="title mt-2">
          {/* <strong>{e.Comment}</strong> */}
          <strong>کارگاه حضوری اکسیژن عاطفی</strong>
        </div>
        {/* <div className='d-grid mb-2'>
                    <span className='bg-success text-white px-2 py-1 wp-text'>{(e.Start_Date !== null) ? <span className='wp-text-small'>از </span> : <span></span>}<b>{e.Start_Date}</b></span>
                    {(e.End_Date !== null) ? <span className='bg-danger text-white px-2 py-1 wp-text'><span className='wp-text-small'>تا </span><b>{e.End_Date}</b></span> : <span></span>}
                </div> */}
        <div className="bg-primary text-white px-2 py-1 wp-text mt-2">
          تعداد همراهان: <b>{e.Count}</b>
        </div>
        <div className="describe mt-2">
          {e !== null &&
          e.data_addition !== null &&
          e.data_addition.length > 0 &&
          e.Count > 0
            ? e.data_addition.map((ee) => {
                return (
                  <p className="mb-1">
                    <span className="badge bg-success p-2"> </span>{" "}
                    {ee.Relation_Title} - {ee.F_Name} {ee.L_Name} (کدملی{" "}
                    {ee.National_Code})
                  </p>
                );
              })
            : null}
        </div>
        {e.State === "1" ? (
          <div className="text-left">
            <button
              type="button"
              onClick={() => this.handleRequest(e.ID)}
              className="btn btn-danger btn-sm rounded-pill py-0 px-1 small-font"
            >
              انصراف
            </button>
          </div>
        ) : null}
      </li>
    ));
    if (this.state.isRegister === true) {
      return (
        <React.Fragment>
          <div className="w-100 body-padding">
            <p className="wp-header small">درخواست های ثبت شده قبلی</p>
            <ul className="Array p-0 mb-5">
              {myRequest.length === 0 ? (
                <li className="Array-item">
                  <div className="title">
                    هنوز درخواستی توسط شما ثبت نشده است.
                  </div>
                </li>
              ) : (
                myRequest
              )}
            </ul>
            {myRequest.length === 0 ? (
              <button
                onClick={this.toggleRegister}
                className="btn btn-success wp-button-add"
              >
                <span>شرکت در کارگاه</span>
              </button>
            ) : (
              <button
                onClick={this.toggleEdit}
                className="btn btn-primary wp-button-add"
              >
                <span>ویرایش درخواست</span>
              </button>
            )}
          </div>
        </React.Fragment>
      );
    } else {
      if (this.state.stepNo === 1) {
        return (
          <React.Fragment>
            <div className="w-100 body-padding">
              <p className="wp-header text-center">
                «کارگاه حضوری اکسیژن عاطفی»
              </p>
              <div className="row justify-content-center">
                <p className="text-center mb-2">
                  آموزش تکنیک مهر و قدرت، آشنایی با دنیای متفاوت زنان و مردان،
                  تکنیک های افزایش صمیمیت همسران، راهکارهای حل تعارض
                </p>
                <div className="col-auto col-8 text-center">
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={Delneshin}
                    title="کارگاه اکسیژن عاطفی"
                  >
                    <img
                      className="Delneshin"
                      src={Delneshin}
                      alt="کارگاه اکسیژن عاطفی"
                    ></img>
                  </a>
                </div>
                <div className="col-12 my-2">
                  <div className="alert alert-danger">
                    <strong>نکته مهم </strong>{" "}
                    <span>
                      با توجه به موضوع کارگاه لطفاً از آوردن کودکان بالای 2 سال
                      خودداری نمایید.
                    </span>
                  </div>
                </div>
                <div className="col-12 text-left mt-2">
                  <button
                    onClick={this.toggledecline}
                    className="btn btn-sm btn-danger"
                  >
                    <span>انصراف</span>
                  </button>
                  <button
                    onClick={this.toggleSubmit}
                    className="btn btn-sm btn-success mr-2"
                  >
                    <span>ادامه</span>
                  </button>
                </div>
              </div>
            </div>
          </React.Fragment>
        );
      } else if (this.state.stepNo === 2) {
        return (
          <React.Fragment>
            <div className="w-100 body-padding">
              <div className="alert alert-info p-1 mt-1">
                <i className="fa fa-info"></i>
                <strong>پیغام!</strong>
                <p className="text-justify mb-0 wp-text-small">
                  در صورتی که اطلاعات خانوار شما ناقص است، نسبت به تکمیل آن
                  اقدام نمایید.
                </p>
              </div>
              <div className="row justify-content-center">
                <div className="col-12">
                  <div className="text-left mb-2">
                    <button
                      onClick={this.props.toggleRelation}
                      className="btn btn-sm btn-primary"
                    >
                      <span>+ افزودن</span>
                    </button>
                  </div>
                  <ul className="Array p-0 mb-2">
                    {myRelation.length === 0 ? (
                      <li className="Array-item">
                        <div className="title">
                          اطلاعات اعضای خانوار شما در سامانه ثبت نشده است.
                        </div>
                      </li>
                    ) : (
                      myRelation
                    )}
                  </ul>
                  <div className="text-left">
                    <button
                      onClick={this.toggledecline}
                      className="btn btn-sm btn-danger"
                    >
                      <span>بازگشت</span>
                    </button>
                    <button
                      onClick={this.toggleSubmit}
                      className="btn btn-sm btn-success mr-2"
                    >
                      <span>تایید و انتخاب همراهان</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </React.Fragment>
        );
      } else if (this.state.stepNo === 3) {
        return (
          <React.Fragment>
            <div className="w-100 body-padding">
              <p className="wp-header">نفر اصلی</p>
              <div className="col-12 bg-light dvBasePerson active">
                <div className="w-100 rounded p-1">
                  <span className="bg-dark text-white wp-text-small rounded p-1">
                    نسبت: نفر اصلی
                  </span>
                  <div className="title mt-1">
                    <strong>{this.props.userJson.full_name}</strong>
                  </div>
                  <div className="describe">
                    کدملی: <b>{this.props.userJson.national_id}</b>
                  </div>
                </div>
              </div>
              <p className="wp-header">انتخاب روز دوره</p>
              <div className="row">
                <div className="col-12">
                  <select className="form-select" id="ID_Type" name="ID_Type">
                    <option value="0">روز کارگاه را انتخاب کنید</option>
                    <option value="1">دوشنبه 22 اردیبهشت ماه</option>
                    <option value="2">پنجشنبه 25 اردیبهشت ماه</option>
                  </select>
                </div>
              </div>
              <p className="wp-header">انتخاب همراهان</p>
              <div className="alert alert-danger p-1 mt-1">
                <i className="fa fa-info"></i>
                <strong>پیغام!</strong>
                <p className="text-justify mb-0 wp-text-small">
                  همراهان خود را از فهرست زیر انتخاب و سپس ثبت نهایی درخواست را
                  کلیک نمایید.
                </p>
              </div>
              <div className="row justify-content-center">
                <div className="col-12">
                  <ul className="Array p-0 mb-2">
                    {Relation_Active.length === 0 ? (
                      <li className="Array-item">
                        <div className="title">
                          همراهی برای اضافه کردن به همراهان وجود ندارد.
                        </div>
                      </li>
                    ) : (
                      Relation_Active
                    )}
                  </ul>
                  <div className="text-left">
                    <button
                      onClick={this.toggledecline}
                      className="btn btn-sm btn-danger"
                    >
                      <span>بازگشت</span>
                    </button>
                    <button
                      onClick={this.toggleSubmit}
                      className="btn btn-sm btn-success mr-2"
                    >
                      <span>ثبت نهایی درخواست</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </React.Fragment>
        );
      }
    }
  }
}
export default Cermony;
